import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 14, className = "", interactive = false, onSelect }) => (
  <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        disabled={!interactive}
        onClick={interactive ? () => onSelect?.(i) : undefined}
        data-testid={interactive ? `star-${i}` : undefined}
        className={interactive ? "cursor-pointer" : "cursor-default"}
      >
        <Star
          size={size}
          className={i <= Math.round(value) ? "fill-[#EAB308] text-[#EAB308]" : "text-zinc-600"}
        />
      </button>
    ))}
  </div>
);
